import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/survey/:id?",
      name: "survey",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Survey.vue")
    },
    {
      path: "/feedback/:id?",
      name: "feedback",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Feedback.vue")
    },
    {
      path: "/thankyou",
      name: "thankyou",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Thankyou.vue")
    }
  ],
  mode: "history"
});

export default router;
